import { render, staticRenderFns } from "./InfoConcept.vue?vue&type=template&id=1288b278&scoped=true&"
import script from "./InfoConcept.vue?vue&type=script&lang=js&"
export * from "./InfoConcept.vue?vue&type=script&lang=js&"
import style0 from "./InfoConcept.vue?vue&type=style&index=0&id=1288b278&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288b278",
  null
  
)

export default component.exports